"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VOICE_OVER_PRICES_V2 = exports.VOICE_OVER_PRICES = void 0;
var VOICE_OVER_PRICES = [{
  billingEntityCode: 'US',
  prices: [210, 275, 375]
}, {
  billingEntityCode: 'AUS',
  prices: [295, 389, 525]
}, {
  billingEntityCode: 'SG',
  prices: [295, 385, 525]
}, {
  billingEntityCode: 'ASIA_US',
  prices: [300, 420, 600]
}, {
  billingEntityCode: 'HK',
  prices: [1600, 2150, 2900]
}, {
  billingEntityCode: 'UK',
  prices: [170, 185, 225]
}, {
  billingEntityCode: 'EU',
  prices: [190, 250, 300]
}]; // this is used in new animation workflow

exports.VOICE_OVER_PRICES = VOICE_OVER_PRICES;
var VOICE_OVER_PRICES_V2 = [{
  billingEntityCode: 'US',
  prices: [210, 275, 375]
}, {
  billingEntityCode: 'AUS',
  prices: [325, 425, 580]
}, {
  billingEntityCode: 'SG',
  prices: [300, 400, 540]
}, {
  billingEntityCode: 'ASIA_US',
  prices: [300, 420, 600]
}, {
  billingEntityCode: 'HK',
  prices: [1659, 2150, 3000]
}, {
  billingEntityCode: 'UK',
  prices: [195, 255, 350]
}, {
  billingEntityCode: 'EU',
  prices: [220, 280, 390]
}];
exports.VOICE_OVER_PRICES_V2 = VOICE_OVER_PRICES_V2;